export default "__VITE_ASSET__9f2ff6c1__"